import { render } from "./DeputyList.vue?vue&type=template&id=77f69b42&scoped=true"
import script from "./DeputyList.vue?vue&type=script&lang=js"
export * from "./DeputyList.vue?vue&type=script&lang=js"

import "./DeputyList.vue?vue&type=style&index=0&id=77f69b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f69b42"]])

export default __exports__